import { cTramite } from "./../../modelos/tramite.modelo";
import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { Router } from "@angular/router";
import * as myGlobals from "../../modelos/globales.modelo";
import * as Tramites from "../../modelos/tramite.modelo";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatAccordion } from "@angular/material/expansion";
import { ApiAppService } from "./../../servicios/apiapp.service";

// Declaramos las variables para jQuery
declare let jquery: any;
declare let $: any;

@Component({
    selector: "app-info-tramites-area",
    templateUrl: "infotramitesarea.component.html",
    styleUrls: ["infotramitesarea.component.css"],
    providers: [ApiAppService],
    standalone: false
})
export class InfoTramitesAreaComponent implements OnInit {
  @Input() idAreaActiva: number;
  public aDatos: Tramites.cTramite[];

  @ViewChild("acordeon", { static: true }) oAcordeon: MatAccordion;

  panelOpenState = true;

  constructor(
    public oRouter: Router,
    public _ApiAppService: ApiAppService,
  ) {}

  ngOnInit() {
    this.CargarTramitesArea();
  }

  // Carga de todos los trámites del área recibida
  CargarTramitesArea(): void {
    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Cargando trámites, espere ...",
      "",
    );

    // Cargamos todos los trámites del cliente

    this._ApiAppService
      .ObtenerTodosLosDocumentosTramite(this.idAreaActiva)
      .subscribe(
        (data) => {
          if (!myGlobals.isNullUndefined(data) && data.length > 0) {
            // Convertimos la colección de objetos interface a colección de clases

            this.aDatos = Tramites.convertirAClase(data, this.idAreaActiva);
          } else {
            this.aDatos = null;
          }
        },
        (err) => {
          myGlobals.CapturaMensajeHTTP(err, true);
        },
      );
    myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
  }

  // Conectamos con la petición de cita
  PedirCita(oTramite: cTramite) {
    let citatemporal = null;
    if (!myGlobals.isNullUndefined(oTramite)) {
      citatemporal = {
        id_area: oTramite.id_fk_area,
        id_tramite: oTramite.id_tramite,
      };

      myGlobals.setSessionStore(
        myGlobals.eSessionStore.citatemporal,
        JSON.stringify(citatemporal),
      );
      this.oRouter.navigateByUrl("/citas");
    }
  }
}
